import React from 'react';
import { motion } from 'framer-motion';
import { HammerIcon, WrenchIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function ServicePresentation() {
  const {
    t
  } = useLanguage();
  const remodelacion = t('services.remodeling.items');
  const restauracion = t('services.restoration.items');
  return <section id="servicios" className="py-12 bg-brand-bg-light" data-id="element-287">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-289">
          <div className="text-center mb-8" data-id="element-290">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-white mb-4 tracking-wide" data-id="element-291">
              {t('services.title')}
            </h2>
            <p className="text-xl sm:text-2xl text-brand-gold font-medium mb-2" data-id="element-292">
              {t('services.subtitle')}
            </p>
            <p className="text-lg text-gray-400" data-id="element-293">{t('services.description')}</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-6" data-id="element-294">
            {/* Remodelación */}
            <motion.div initial={{
            opacity: 0,
            x: -40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="bg-brand-bg-dark rounded-2xl border border-brand-green/30 overflow-hidden shadow-xl shimmer-border shimmer-border-green" data-id="element-295">
              <div className="bg-brand-green-dark p-6 flex items-center justify-center gap-4 border-b border-brand-green" data-id="element-296">
                <HammerIcon className="w-8 h-8 text-white" data-id="element-297" />
                <h3 className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-298">
                  {t('services.remodeling.title')}
                </h3>
              </div>
              <div className="p-0" data-id="element-299">
                <table className="w-full text-left border-collapse" data-id="element-300">
                  <tbody data-id="element-301">
                    {Array.isArray(remodelacion) && remodelacion.map((item: any, index: number) => <motion.tr key={index} initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.4,
                    delay: index * 0.08
                  }} className="border-b border-gray-800 hover:bg-white/5 transition-colors" data-id="element-302">
                          <td className="py-4 px-6 font-heading font-bold text-brand-gold text-lg w-1/3 align-top" data-id="element-303">
                            {item.name}
                          </td>
                          <td className="py-4 px-6 text-gray-300" data-id="element-304">
                            {item.desc}
                          </td>
                        </motion.tr>)}
                  </tbody>
                </table>
              </div>
            </motion.div>

            {/* Restauración */}
            <motion.div initial={{
            opacity: 0,
            x: 40
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            ease: 'easeOut',
            delay: 0.2
          }} className="bg-brand-bg-dark rounded-2xl border border-brand-gold/30 overflow-hidden shadow-xl shimmer-border" data-id="element-305">
              <div className="bg-brand-gold-dark p-6 flex items-center justify-center gap-4 border-b border-brand-gold" data-id="element-306">
                <WrenchIcon className="w-8 h-8 text-white" data-id="element-307" />
                <h3 className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-308">
                  {t('services.restoration.title')}
                </h3>
              </div>
              <div className="p-0" data-id="element-309">
                <table className="w-full text-left border-collapse" data-id="element-310">
                  <tbody data-id="element-311">
                    {Array.isArray(restauracion) && restauracion.map((item: any, index: number) => <motion.tr key={index} initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.4,
                    delay: index * 0.08
                  }} className="border-b border-gray-800 hover:bg-white/5 transition-colors" data-id="element-312">
                          <td className="py-4 px-6 font-heading font-bold text-brand-gold text-lg w-1/3 align-top" data-id="element-313">
                            {item.name}
                          </td>
                          <td className="py-4 px-6 text-gray-300" data-id="element-314">
                            {item.desc}
                          </td>
                        </motion.tr>)}
                  </tbody>
                </table>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}